module.exports = __webpack_public_path__ + "img/20200104131330360截图20200104102007442.d52006a7.jpg";